/**
 * Salon is mounted under /salon (skin stays at /). Route prefix + storage keys
 * are isolated so the two flows do not share sessionStorage/localStorage entries.
 */

export const SALON_APP_BASE = '/nyafaz-ep/salon';

/** App picker (salon skin flow vs makeup-hair). */
export const SALON_HUB_PATH = `${SALON_APP_BASE}/hub`;
/** Makeup / hair styling / hair coloring studios (not on production hub). */
export const SALON_TEST_HUB_PATH = `${SALON_APP_BASE}/test`;
/** Post-identity: Select service vs Analyze. */
export const SALON_VISIT_INTENT_PATH = `${SALON_APP_BASE}/visit-intent`;
/** Guest kiosk: analysis vs direct services, then confirm to desk. */
export const SALON_GUEST_INTENT_PATH = `${SALON_APP_BASE}/guest-intent`;
export const SALON_GUEST_CONFIRM_PATH = `${SALON_APP_BASE}/guest-confirm`;
/** Stylist-led mobile lookup (primary franchise check-in). */
export const SALON_STYLIST_CHECKIN_PATH = `${SALON_APP_BASE}/stylist-checkin`;
/** Stylist picks guest + assigns self before starting flow. */
export const SALON_STYLIST_GUEST_PATH = `${SALON_APP_BASE}/stylist-guest`;
/** Staff assign + price list session + finish. */
export const SALON_SERVICE_LOBBY_PATH = `${SALON_APP_BASE}/service-lobby`;
export const SALON_SERVICE_SESSION_PATH = `${SALON_APP_BASE}/service-session`;
/** Browse franchise catalog by gender and category (no checkout). */
export const SALON_SERVICE_CATALOG_PATH = `${SALON_APP_BASE}/service-catalog`;
export const SALON_SERVICE_WORK_PATH = `${SALON_APP_BASE}/service-work`;
/** Choice screen (code vs face) — idle / pre-check-in home. */
export const SALON_START_PATH = `${SALON_APP_BASE}/start`;
/** Kiosk landing page (branded entry). Prefer SALON_START_PATH for idle Home. */
export const SALON_HOME_PATH = SALON_APP_BASE;

/** Turn an app path like /user-info into /nyafaz-ep/salon/user-info. `/` → `/nyafaz-ep/salon`. */
export function salonAppPath(path) {
  const raw = path == null || path === '' ? '/' : String(path);
  const p = raw.startsWith('/') ? raw : `/${raw}`;
  if (p === '/') return SALON_HOME_PATH;
  if (p === SALON_APP_BASE || p.startsWith(`${SALON_APP_BASE}/`)) return p;
  return `${SALON_APP_BASE}${p}`;
}

export const SALON_APP_SESSION_TOKEN_KEY = 'enterprise_salon_app_session_token';
export const SALON_ORG_PLAN_KEY = 'enterprise_salon_org_plan';
export const SALON_SESSION_HOME_PATH_KEY = 'enterprise_salon_session_home_path';
export const SALON_DETECTION_SESSION_KEY = 'enterprise_salon_detection_session_id';
export const SALON_PENDING_SAVE_KEY = 'enterprise_salon_pending_save_analysis_v1';
export const SALON_PAGE_SETUP_TOKEN_KEY = 'enterprise_salon_page_setup_token';
export const SALON_PAGE_SETUP_DATA_PREFIX = 'enterprise_salon_page_setup_data_';
export const SALON_FLOW_STATE_PREFIX = 'enterprise_salon_flow_state_';
export const SALON_CACHE_KEY_PREFIX = 'enterprise_salon_analysis_cache_';
export const SALON_PENDING_SAVES_KEY = 'enterprise_salon_analysis_pending_saves';

/** sessionStorage key prefix for last saved customer profile on salon user-info (per app session token). */
export const SALON_LAST_CUSTOMER_PREFIX = 'enterprise_salon_last_customer_v1_';

export function salonLastCustomerStorageKey(token) {
  const t = token && String(token).trim() ? String(token).trim() : '_default';
  return `${SALON_LAST_CUSTOMER_PREFIX}${t}`;
}
